<template>
  <div class="aw-contact">
    <div></div>
    <div class="com-desc-box container-center">
      <ul class="company-address">
        <li v-for="(item, index) in addressList" :key="index">
          <div class="imgbox">
            <img
              class="address-icon"
              src="@/assets/about/icon_position@2x.png"
            />
            <span class="text-box-h">{{ item.city }}</span>
          </div>
          <div class="text-box">
            {{ item.address }}
          </div>
        </li>
      </ul>
      <div class="hotlinebox">
        <div class="hotline-box-left">
          <div class="holine-box-address" style="margin-bottom: 12px">
            <div class="holine-box-phone">
                <div class="text-box-title">
                <img
                    class="icon-img"
                    src="@/assets/about/icon_phone@2x.png"
                    alt=""
                />
                咨询热线
                </div>
                <div class="text-box">
                4000-365-805
                </div>
            </div>

            <div class="holine-box-address-item m-item-margin">
              <div class="text-box-title">
                <img
                  class="icon-img"
                  src="@/assets/about/icon_mail@2x.png"
                  alt=""
                />
                商务合作
              </div>
              <div class="text-box">sales@awcloud.com</div>
            </div>

            <div class="holine-box-address-item m-item-margin">
              <div class="text-box-title">
                <img
                  class="icon-img"
                  src="@/assets/about/icon_mail@2x.png"
                  alt=""
                />
                技术支持
              </div>
              <div class="text-box">support@awcloud.com</div>
            </div>
          </div>
          <div class="holine-box-address">
            <div class="holine-box-address-item m-item-margin">
              <div class="text-box-title">
                <img
                  class="icon-img"
                  src="@/assets/about/icon_mail@2x.png"
                  alt=""
                />
                培训咨询
              </div>
              <div class="text-box">training@awcloud.com</div>
            </div>

            <div class="holine-box-address-item m-item-margin">
              <div class="text-box-title">
                <img
                  class="icon-img"
                  src="@/assets/about/icon_mail@2x.png"
                  alt=""
                />
                市场宣传
              </div>
              <div class="text-box">marketing@awcloud.com</div>
            </div>
          </div>
        </div>

        <div class="hotline-box-right">
          <!-- <div class="right-box">
            <p>
              关注微信公众号<br />
              及时了解更多产品及动态
            </p>
          </div> -->
          <div class="qrcode">
            <div class="img-mr">
                <img src="@/assets/about/contact_img_QRcode_office.png" alt="" />
                <p class="qrcode-desc-title">海云捷迅AWCloud</p>
            </div>
            <div class="img-mr">
                <img src="@/assets/about/contact_img_QRcode_class.png" alt="" />
                <p class="qrcode-desc-title">海云学堂</p>
            </div>
            <div>
                <img src="@/assets/about/contact_img_QRcode.png" alt="" />
                <p class="qrcode-desc-title">AIStack智算中心</p>
            </div>
          </div>
          <div class="qrcode-desc-title">
            关注相关微信公众号，了解更多信息
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryContactList } from "@/api/common.js";
export default {
  data() {
    return {
      addressList: [
        {
          city: "北京总部",
          address: "北京市海淀区知春路106号 太平洋国际大厦写字楼11层",
        },
        {
          city: "重庆",
          address: "重庆市沙坪坝区学城大道62-1号研发楼一期B3栋",
        },
        {
          city: "武汉",
          address: "湖北省武汉市东湖高新区光谷大道金融港A9栋402室",
        },
        {
          city: "深圳",
          address: "广东省深圳市南山区粤海街道比克科技大厦2401H",
        },
        {
          city: "大连",
          address: "辽宁省大连市甘井子区大连软件园腾飞园区1号楼304",
        },
        {
          city: "福州",
          address: "福建省福州市长乐区文武砂镇东南大数据产业园2期",
        },
      ],
    };
  },
  methods: {
    queryContact() {
      queryContactList().then((res) => {
        if(res && res.code == 200) {
            let { extendInfo } = res.data
            extendInfo = JSON.parse(extendInfo)
            this.addressList = extendInfo.offices
        }
      });
    },
  },
  mounted() {
    this.queryContact();
  },
};
</script>